function filterStores() {

	var filters = document.querySelectorAll('.store-cat-item');
	var stores = document.querySelectorAll('.store-list-grid--item');

	filters.forEach(function(filter) {
	   filter.addEventListener("click", function (e) {

	   		var cat = filter.dataset.cat;

			filters.forEach(function(filter) {
				filter.classList.remove('active')
			});
			filter.classList.add('active');

			if(cat == 'all') {
				stores.forEach(function(store) {
					store.style.display = 'block'
				});				
			} else {
				var unselectedStores = document.querySelectorAll('.store-list-grid--item:not(.' + cat + ')');
				unselectedStores.forEach(function(store) {
					store.style.display = 'none'
				});

				var selectedStores = document.querySelectorAll('.store-list-grid--item.' + cat);
				selectedStores.forEach(function(store) {
					store.style.display = 'block'
				});
			}

	   });
	});		

}

filterStores();